import { BILLING_API } from '@Constants/backendConstants';
import {
    EnumOperation,
    ListRequest,
    FilterCondition,
    EnumFilterExpressionOperation,
} from '@synqo/frontend-component-library';
import { EnumInvoiceType, EnumProcessState } from '@Model';
import { useCallback } from 'react';
import { useListApi } from '@Hooks/useListApi';
import { InvoicesRepository } from '@Repositories/Billing';

export function useLoadExportableInvoices() {
    const listApi = useListApi(InvoicesRepository, BILLING_API, ['all']);

    const loadPage = useCallback(
        (listRequest: ListRequest) => {
            const filters: FilterCondition[] = [
                {
                    field: 'process_state',
                    value: EnumProcessState.Approved.toString(),
                    operator: EnumOperation.Equal,
                },
                {
                    field: 'type',
                    value: EnumInvoiceType.Cancellation.toString(),
                    operator: EnumOperation.NotEqual,
                },
            ];

            if (listRequest.filter_columns === undefined) {
                listRequest.filter_columns = { operation: EnumFilterExpressionOperation.And, filters: [] };
            }

            listRequest.filter_columns.filters.push(...filters);

            return listApi.loadPage(listRequest);
        },
        [listApi],
    );

    return {
        loadPage,
    };
}
